export default __webpack_public_path__ + "static/media/careadmin_patient_icon.13e77fe4.svg";